module.exports = __webpack_public_path__ + "img/Hc.2e9b1422.png";